import React from 'react';
import DepartmentProcessForm from '../../components/transaction/DepartmentProcessForm';
import { Container, Paper, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const DepartmentProcessPage = () => {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Container component="main" maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, md: 3 } }}>
          <DepartmentProcessForm />
        </Paper>
      </Container>
    </>
  );
};

export default DepartmentProcessPage; 